<template>
    <div>
        <b-modal :id="modalId"
                modal-class="modal-error"
                centered
                hide-header
                hide-footer
                no-close-on-backdrop
                no-close-on-esc>
            <div class="modal-base"
                :class="[{'mass': theme == 'mass'}, {'prestige': theme == 'prestige'}]">
                <div class="modal-base-body">
                    <p id="alert_msg" v-html="message"></p>
                </div>
                <div class="modal-base-footer">
                    <div id="alert_btn_row">
                        <div class="alert-modal-btn">
                            <PrimaryButton
                                btnId="confirm_alert_btn"
                                :btnMsg="btnConfirm"
                                @clickButton="clickConfirm()" />
                        </div>
                    </div>
                </div>
            </div>
        </b-modal>
    </div>
</template>
<script>
import Util from "@/helper/Utility.js";
import LocaleMixin from "@/mixin/LocaleMixin.js";
// components
// import SecondaryButton from "@/components/Button/SecondaryButton.vue";
import PrimaryButton from "@/components/Button/PrimaryButton.vue";
/**
 * @property {AlertModalController} controller (required) /components/Modal/Controller/AlertModalController.js
 * @property {String} modalId (reqquired)
 */
export default {
    name: "ErrorModal",
    mixins: [LocaleMixin],
    components: {
        PrimaryButton,
        // SecondaryButton
    },
    computed: {
        theme: function () {
            return this.$store.state.theme;
        }
    },
    props: {
        controller: Object,
        modalId: String,
    },
     data: function() {
        return {
            title: '',
            message: '',
            btnConfirm: '',
            btnCancel: '',
            tag: '',
            busModal: null,
        };
    },
    created: function() {
        this.busModal = this.controller.busModal;
    },
    mounted: function() {
        this.busModal.$on('show', this.show);
        this.busModal.$on('hide', this.hide);
    },
    methods: {
        clickConfirm: function () {
            this.hide();
        },
        clickCancel: function () {
            this.hide();
        },
        show: function(config) {
            this.title = config.title;
            this.message = config.msg;
            this.btnConfirm = config.btnConfirm;
            this.btnCancel = config.btnCancel;
            this.tag = config.tag;

            if (Util.isEmptyStr(config.title))
                this.title = this.lbl.default.error_title;

            if (Util.isEmptyStr(config.btnConfirm))
                this.btnConfirm = this.lbl.default.confirm;

            if (Util.isEmptyStr(config.btnCancel))
                this.btnCancel = this.lbl.default.cancel;

            this.$bvModal.show(this.modalId);
        },
        hide: function() {
            this.$bvModal.hide(this.modalId);
        }
    },
}
</script>
<style lang="scss" scoped>
@import "@/style/base/base.scss";

p {
    margin-bottom: 0;
}

#alert_title {
    color: #b50c0c;
    font-size: 1.5rem;
    // font-family: $heading;
    // line-height: 1;
    text-align: center;
}

#alert_msg {
    font-size: 1.3rem;
    // font-family: $body;
    // line-height: 1.3;
    text-align: center;
}

#alert_btn_row {
    .alert-modal-btn {
        margin: auto;
    }

    %base-btn-txt {
        font-size: 1.5rem;
        // font-family: $heading;
    }
}
</style>
<style lang="scss">
@import "@/style/base/base.scss";
@import "@/style/modal.scss";
.modal-error {
    @extend %modal-base;

    .modal-dialog {
        margin: {
            left: 15px;
            right: 15px;
        };

        .modal-content {
            .modal-body {
                padding: 0;

                .modal-base {
                    padding: {
                        left: 40px;
                        right: 40px;
                    };
                    border-radius: 10px;

                    &.mass {
                        background-color: #ffffff;

                        #alert_msg {
                            color: $mass_modal_message;
                        }
                    }

                    &.prestige {
                        background-color: #fffdf8;

                        #alert_msg {
                            color: $prestige_modal_message;
                        }
                    }

                    .modal-base-head {
                        padding: {
                            top: 30px;
                            bottom: 0;
                        };
                    }

                    .modal-base-body {
                        padding: {
                            top: 30px;
                            bottom: 30px;
                        };
                    }

                    .modal-base-footer {
                        padding: {
                            left: 5px;
                            right: 5px;
                            bottom: 35px;
                        };
                    }
                }
            }
        }
    }
}
</style>
